
import store from '@/store';
import {
  computed, defineComponent,
} from '@vue/composition-api';

export default defineComponent({
  setup() {
    function clearSelection() {
      store.dispatch.clearSelection();
    }

    const rightClickMenu = computed(() => store.state.rightClickMenu);

    return {
      rightClickMenu,
      clearSelection,
    };
  },
});
